<template>
  <mChartDom :option="getLineOption"/>
</template>

<script>
import mChartDom from "./mChartDom";

export default {
  components: {
    mChartDom
  },
  name: "mLine",
  props: {
    option: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      defaultOption: {
        color: ['#0082FF','#FF5B5B','#FFBA36','#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          bottom: "bottom"
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            color: '#999'
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#999'
          },
          // splitLine: {
          //   show: false
          // }
        },
        series: [
          {
            type: 'line',
            data: []
          }
        ]
      },
    };
  },
  computed: {
    getLineOption() {
      return {
        ...this.defaultOption,
        ...(this.option || {})
      };
    }
  }
};
</script>

<style scoped>
#dom {
  min-width: 100px;
  min-height: 100px;
  height: 100%;
}
</style>
